import React from "react"
import { Link } from "react-router-dom"
import Back from "../common/back/Back"
import "./features.css"

const steps = [
  { n: "01", title: "Enroll in the Signature Programme", desc: "Complete the full Rovers Access Signature Programme — from platform orientation through to advanced trend and zone combination trading." },
  { n: "02", title: "Complete All Modules", desc: "Work through all 6 structured modules covering charts, candles, demand/supply zones, proximal/distal lines, trends, and live trading." },
  { n: "03", title: "Attend Live Sessions", desc: "Participate in live trading sessions, market reviews, and one-on-one mentorship as part of your learning journey." },
  { n: "04", title: "Pass Final Assessment", desc: "Demonstrate your understanding of trading concepts, risk management, and chart analysis through a practical assessment." },
  { n: "05", title: "Receive Your Certificate", desc: "Earn your industry-recognised Rovers Access trading certificate — a testament to your practical skills and financial market knowledge." },
]

const benefits = [
  { icon: "fa fa-check-circle",  text: "Validates your trading knowledge to employers, partners, and clients." },
  { icon: "fa fa-check-circle",  text: "Demonstrates disciplined, risk-aware trading capability." },
  { icon: "fa fa-check-circle",  text: "Recognised by Rovers Access Limited — Kenya's practical trading education leader." },
  { icon: "fa fa-check-circle",  text: "Includes a unique certificate ID stored in your student profile." },
  { icon: "fa fa-check-circle",  text: "A mark of commitment — separates you from self-taught and untrained traders." },
]

const TradingCertificate = () => (
  <>
    <Back title="Earn a Trading Certificate" />

    <section className="feature-page padding">
      <div className="container">

        {/* Hero intro */}
        <div className="feature-intro">
          <div className="feature-intro-icon award">
            <i className="fa fa-award"></i>
          </div>
          <div className="feature-intro-text">
            <p className="feature-eyebrow">CERTIFICATION</p>
            <h2>Prove Your Trading Knowledge</h2>
            <p>
              Complete our Signature Programme and earn an <strong>industry-recognised
              certificate</strong> that validates your market knowledge and trading skills. It's
              not just a document — it's proof that you understand trading the right way.
            </p>
            <p>
              We measure success not by how many certificates we issue, but by how many
              students trade <strong>responsibly, manage losses gracefully, and grow
              consistently</strong>.
            </p>
          </div>
        </div>

        {/* Steps to earn */}
        <div className="feature-section">
          <h3 className="feature-section-title"><i className="fa fa-road"></i> How to Earn Your Certificate</h3>
          <div className="cert-steps">
            {steps.map((s, i) => (
              <div className="cert-step" key={i}>
                <div className="cert-step-num">{s.n}</div>
                <div className="cert-step-content">
                  <h4>{s.title}</h4>
                  <p>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits */}
        <div className="feature-section">
          <h3 className="feature-section-title"><i className="fa fa-star"></i> Why It Matters</h3>
          <div className="feature-benefits">
            {benefits.map((b, i) => (
              <div className="feature-benefit-item" key={i}>
                <i className={b.icon}></i>
                <span>{b.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Certificate preview card */}
        <div className="feature-section">
          <div className="cert-preview-card">
            <div className="cert-preview-logo">
              <img src="/images/logo.png" alt="Rovers Access" />
            </div>
            <div className="cert-preview-content">
              <p className="cert-preview-issuer">ROVERS ACCESS LIMITED</p>
              <h3>Certificate of Completion</h3>
              <p className="cert-preview-programme">Signature Trading Programme</p>
              <p className="cert-preview-sub">Awarded upon successful completion of all modules and assessments</p>
              <div className="cert-preview-badge">
                <i className="fa fa-award"></i> Nairobi, Kenya · Learn | Trade | Grow
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="feature-section feature-cta-section">
          <h3>Start your journey towards certification</h3>
          <p>Enroll in the Signature Programme and earn your certificate upon completion.</p>
          <div className="feature-cta-btns">
            <Link to="/courses" className="feature-btn primary">
              <i className="fa fa-graduation-cap"></i> View Signature Programme
            </Link>
            <a href="https://wa.me/254722525826" target="_blank" rel="noreferrer" className="feature-btn whatsapp">
              <i className="fab fa-whatsapp"></i> Ask Us More
            </a>
          </div>
        </div>

      </div>
    </section>
  </>
)

export default TradingCertificate
